import type { FaireProductEntity } from "../../entity_types/product";

export const p_r6s7sy58me: FaireProductEntity = {
  token: "p_r6s7sy58me",
  type: "product",
  name: "Bud Vase Sending Love Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6463931d035654c7363009850bcb9a4470ee0a0da46ecf7c3175bc2745090780.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57d23e6c5ca592630630f520b8117b8f6ff8cba9fe803964f94d4db8e4726f71.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Sometimes simpler is better. Just letting someone know you're thinking of them is all you need to do.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:27.624Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
